module.exports = __webpack_public_path__ + "static/img-opinion-fc1a4050c325a9c8dc9dc139d441bb61.webp";